import React from 'react';
import { useIntl } from 'react-intl';
import { Evidence, useDictionaryEvidence } from '@eas/common-web';
import { ExportTags } from '../../../common/export-tags';
import { Tag } from '../../../common/models';
import { initNewDisabledItem } from '../../../utils/dictionary-item';
import { useValidationSchema } from './tags-schema';

export function OperatorTags() {
  const intl = useIntl();
  const validationSchema = useValidationSchema();

  const evidence = useDictionaryEvidence<Tag>({
    identifier: 'TAGS',
    apiProps: {
      url: '/api/ks/tags',
    },
    tableProps: {
      tableName: intl.formatMessage({
        id: 'KS_O_TAGS_TABLE_TITLE',
        defaultMessage: 'Klíčová slova',
      }),
      reportTag: ExportTags.TAG_GRID,
    },
    detailProps: {
      validationSchema,
      initNewItem: initNewDisabledItem,
    },
  });

  return <Evidence {...evidence} />;
}
